export enum EN_CONFIRM_PASSWORD_SESSION_KEY {
  MEMBER_INFO = 'inMemberInfo',
  WITHDRAW = 'inWithdraw',
}

export interface IMemberConfirmPasswordRequestParams {
  body: {
    password: string;
    ywt?: string;
    sessionKey?: EN_CONFIRM_PASSWORD_SESSION_KEY;
  };
}
